var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 34,
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.1,
    height: 34,
    rx: 17,
    width: 34
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 33,
    rx: 16.5,
    stroke: "#fff",
    strokeOpacity: 0.2,
    width: 33,
    x: 0.5,
    y: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17 11a3.51 3.51 0 0 0-1.22.217 3.272 3.272 0 0 0-1.045.627c-.302.27-.545.595-.712.956a2.75 2.75 0 0 0-.213.68H11.46a.463.463 0 0 0-.461.465c0 .257.207.465.462.465h.769v2.698c0 1.013.142 2.02.423 2.993a3.925 3.925 0 0 0 3.112 2.787l.097.017a6.826 6.826 0 0 0 2.274 0l.097-.017a3.925 3.925 0 0 0 3.112-2.787c.28-.973.423-1.98.423-2.993V14.41h.77a.463.463 0 0 0 .461-.465.463.463 0 0 0-.461-.465H20.19a2.75 2.75 0 0 0-.213-.68 2.947 2.947 0 0 0-.712-.956 3.272 3.272 0 0 0-1.046-.627A3.51 3.51 0 0 0 17 11zm-.9 1.09a2.593 2.593 0 0 1 1.8 0c.284.105.54.259.752.449.212.19.377.413.488.653.044.094.079.19.105.288h-4.49c.026-.098.062-.194.105-.288.111-.24.276-.463.489-.653.212-.19.467-.343.75-.449zm-.33 4.49c.254 0 .46.208.46.465v2.48c0 .257-.206.465-.46.465s-.462-.208-.462-.465v-2.48c0-.257.206-.465.461-.465zm2.46 0c.256 0 .462.208.462.465v2.48c0 .257-.206.465-.461.465s-.462-.208-.462-.465v-2.48c0-.257.207-.465.462-.465z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.490634445c13f5f8d6ab2edb1bb1fe29.svg";
export { ForwardRef as ReactComponent };